import { Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges, OnDestroy } from '@angular/core';
import { ImageCacheService } from '../services/image-cache.service';
import { Subscription } from 'rxjs';

@Directive({
    selector: 'img[appCachedImage]',
    standalone: false
})
export class CachedImageDirective implements OnInit, OnChanges, OnDestroy {
  @Input() src: string | null = null;
  private defaultSrc = '/assets/images/default-book.png';
  private subscription: Subscription | null = null;

  constructor(
    private el: ElementRef<HTMLImageElement>,
    private imageCacheService: ImageCacheService
  ) {}

  ngOnInit(): void {
    this.loadImage();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['src']) {
      this.loadImage();
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private loadImage(): void {
    // Önceki subscription varsa iptal et
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (!this.src) {
      this.el.nativeElement.src = this.defaultSrc;
      return;
    }

    // Önce orijinal resmi göster (anlık yükleme)
    this.el.nativeElement.src = this.src;

    // Eğer CDN resmi ise, cache'den kontrol et (arka planda)
    if (this.src.includes('cdn.istanbul')) {
      this.subscription = this.imageCacheService.getImageUrl(this.src).subscribe(
        cachedUrl => {
          // Cache'den farklı bir URL geldiyse (blob URL), güncelle
          if (cachedUrl && cachedUrl !== this.src && cachedUrl.startsWith('blob:')) {
            this.el.nativeElement.src = cachedUrl;
          }
        }
      );
    }

    // Hata durumunda default resmi göster
    this.el.nativeElement.onerror = () => {
      this.el.nativeElement.src = this.defaultSrc;
    };
  }
}
